import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hasPermission'
})
export class HasPermissionPipe implements PipeTransform {
    transform(userPermissions: string[], requiredPermission: string): boolean {
        return userPermissions.includes(requiredPermission);
    }
}